import classNames from 'classnames'
import React from 'react'
import { useOutStockText } from '../hook'

import { ProductOutstock } from '../product-outstock/ProductOutstock'
import useStyles from './ProductOutstockList.styles'
import useRootStyles from '../MenuOutOfStockView.styles'

export const ProductOutstockList = ({ classes, products }) => {
  const componentClasses = useStyles()
  const rootClasses = useRootStyles()
  const title = useOutStockText({ ctaName: 'productTitle' })
  return (
    <div className={componentClasses.root}>
      <div
        className={classNames(
          componentClasses.titleContainer,
          classes.titleContainer,
        )}
      >
        <span className={rootClasses.title}>{title}</span>
      </div>
      <div>
        {products.map((product, index) => {
          return (
            <ProductOutstock
              classes={{
                imageRoot: classNames(
                  componentClasses.productBoxImageRoot,
                  classes.productBoxImageRoot,
                ),
                productInfoContainer: classNames(
                  componentClasses.productBoxProductInfoContainer,
                  classes.productBoxProductInfoContainer,
                ),
                root: classNames(
                  componentClasses.productBoxRoot,
                  classes.productBoxRoot,
                ),
              }}
              key={`t-${index}-${product.id}`}
              product={product}
              showDetails={true}
            />
          )
        })}
      </div>
    </div>
  )
}

ProductOutstockList.defaultProps = {
  classes: {},
  products: [],
}
